import makeStyles from '@mui/styles/makeStyles';

export const useBedManagementStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        height: '100%',
        maxHeight: '100vh',
        backgroundColor: theme.palette.bedManagement.background,
    },
    widgetBox: {
        margin: '0 10px',
    },
    divRow: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        alignItems: 'center',
        '&.marginLeft': {
            paddingLeft: 12
        },
        '&.marginRight': {
            marginRight: 12
        }
    },
    siderooms: {
        width: '100%',
    },
    right: {
        marginLeft: 'auto',
    },
    topWidget: {
        width: 800,
    },
    widgetText: {
        whiteSpace: 'nowrap',
        fontWeight: 'bold',
        fontSize: 14,
        minWidth: 100,
    },
    widgetList: {
        margin: '10px 0',
        gap: 10,
        overflowY: 'auto',
        maxHeight: '250px',
        flexWrap: 'nowrap',
        paddingBottom: 5,
    },
    context: {
        margin: 10,
    },
    toggleRoot: {
        color: theme.palette.designSystem.palette.text1,
        backgroundColor: theme.palette.mode === 'dark' ? '#313233' : '#f2f2f2 !important',
        borderRadius: 9,
        '&.padding': {
            padding: 4,
        },
        '&.noPadding': {
            padding: 0,
        },
        '&.marginLeft': {
            marginLeft: 12
        },
        '&.marginRight': {
            marginRight: 12
        }
    },
    toggleLabel: {
        color: theme.palette.designSystem.palette.text1,
        fontWeight: 'bold',
    },
    toggleSelect: {
        color: theme.palette.mode === 'dark' ? 'black !important' : '#ffffff !important',
        fontWeight: theme.palette.mode === 'dark' ? 400 : 600,
        backgroundColor: theme.palette.mode === 'dark' ? '#ffffff !important' : '#626466 !important',
    },
    widget: {
        backgroundColor: theme.palette.mode === 'light' ? '#f0f0f0' : '#313233',
        padding: 10,
        borderRadius: 8,
        height: 100,
        maxWidth: '25vw',
        '&.panel': {
            width: 120,
            height: 80,
        },
    },
    panel: {
        margin: '20px 10px',
        '&.cleaning': {
            margin: '0px 10px',
        },
    },
    panelWidgetLabel: {
        fontSize: 13,
    },
    panelWidgetValue: {
        fontSize: 22,
        fontWeight: 'bold',
        marginTop: 6,
    },
    background: {
        backgroundColor: theme.palette.bedManagement.background + ' !important',
    },
    rightHeader: {
        marginLeft: 'auto',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 10,
    },
    icon: {
        "&.active": {
            color: theme.palette.primary.main
        }
    },
    global: {
        marginLeft: 10,
        width: '30vw',
        paddingTop: 5,
        display: 'flex',
        alignItems: 'center',
    },
    addWidgetBtn: {
        marginLeft: 'auto',
    },
    panelAction: {
        margin: '10px 0',
        gap: 10,
    },
    selectFields: {
        borderRadius: 8,
        width: '175px !important',
    },
    selectLabel: {
        fontSize: 12,
        fontFamily: 'Inter',
    },
    dropdown: {
        display: 'flex',
        gap: 10,
        marginRight: 10,
    },
    chipClass: {
        height: 28,
        minWidth: 100,
        borderRadius: 30,
        border: `1px solid ${theme.palette.mode === 'dark' ? '#ACAFB3' : '#222425'}`,
        color: theme.palette.mode === 'dark' ? '#ACAFB3' : '#222425',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontFamily: 'Inter',
        fontSize: 13,
        cursor: 'pointer',
        '&.active': {
            border: `1px solid ${theme.palette.mode === 'dark' ? '#ffffff' : '#222425'}`,
            color: theme.palette.mode === 'dark' ? '#313233' : '#ffffff',
            backgroundColor: theme.palette.mode === 'dark' ? '#ffffff' : '#222425',
            fontWeight: 'bold',
        },
    },
    gender: {
        marginRight: 8,
        borderRadius: 6,
        color: '#222425',
        display: 'flex',
        padding: 2,
        '&.Male': {
            backgroundColor: '#92bfe2',
        },
        '&.Female': {
            backgroundColor: '#f4bdd1',
        },
    },
    patientType: {
        display: 'flex', justifyContent: 'center', alignItems: 'center',
        width: "70px",
        borderRadius: 5,
        height: "25px",
        lineHeight: '14px',
        fontWeight: 700,
        border: "1px solid transparent",
        paddingTop: 1,
        fontSize: '12px',
        
        '&.Inpatient': {
            borderColor: "#4981B3",
            color: "#4981B3"
        },
        '&.TCI': {
            borderColor: "#B75BE2",
            color: "#B75BE2"
        },
        '&.ED': {
            borderColor: "#359F9F",
            color: "#359F9F"
        }
    },
    pointer: {
        cursor: 'pointer'
    },
    widgetAmountSection: {
        fontSize: '1.2rem',
        fontWeight: 700,
        display: 'flex',
        alignItems: 'center',
        gap: 10
    },
    widgetAmount: {
        backgroundColor: theme.palette.background.paperDarker,
        borderRadius: 8,
        width: 30,
        height: 30,
        paddingTop: 1,
        textAlign: 'center',
        display: 'inline-block'
    },
    outlinedAgyleButton: {
        color: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
    }
}));